/**
 * Tipos espelhados de `backend/src/saga/types.ts` e `backend/src/dtos/saga.dto.ts`.
 *
 * Não importamos do backend (sem package shared no MVP); cópia consciente.
 * Quando o duplo crescer, considerar package `@wos/shared` via Bun workspaces.
 */

export type SagaStatus =
  | "QUEUED"
  | "RUNNING"
  | "SUCCESS"
  | "FAILED"
  | "COMPENSATING"
  | "FAILED_NEEDS_MANUAL";

export type StepStatus =
  | "PENDING"
  | "OK"
  | "FAILED"
  | "COMPENSATED"
  | "COMPENSATION_FAILED";

/** SPEC-20260507-0132 (Fase 0c): progresso de step long-running. */
export interface HeartbeatEntry {
  ts: string;
  percent?: number;
  message?: string;
}

export interface StepResult {
  step: number;
  name: string;
  status: StepStatus;
  attempts: number;
  output?: unknown;
  input?: unknown;
  error?: { message: string; stack?: string };
  startedAt: string;
  finishedAt?: string;
  /** SPEC-20260507-0132 (Fase 0c): heartbeats de step long-running. */
  heartbeats?: HeartbeatEntry[];
}

export interface SagaRunResult {
  sagaId: string;
  sagaType: string;
  idempotencyKey: string;
  status: SagaStatus;
  currentStep: number;
  totalSteps: number;
  stepResults: StepResult[];
  error?: { step: number; message: string };
  startedAt: string;
  finishedAt?: string;
}

export interface TriggerSagaInput {
  sagaType: string;
  input: unknown;
  idempotencyKey: string;
}

export interface TriggerSagaResult {
  sagaId: string;
  sagaType: string;
  status: SagaStatus;
  statusUrl: string;
  currentStep: number;
  totalSteps: number;
}

export interface ListSagasParams {
  sagaType?: string;
  status?: SagaStatus;
  limit?: number;
  offset?: number;
}

export interface ListSagasResult {
  data: SagaRunResult[];
  pagination: { limit: number; offset: number; total: number };
}

export const TERMINAL_STATUSES: ReadonlySet<SagaStatus> = new Set([
  "SUCCESS",
  "FAILED",
  "FAILED_NEEDS_MANUAL",
]);

export function isTerminal(status: SagaStatus): boolean {
  return TERMINAL_STATUSES.has(status);
}
